module.exports = __webpack_public_path__ + "img/flexible-income-thumbnail.04073732.png";